const filterData = {
  languages: ["English", "Hindi", "Kannada", "Telugu", "Tamil"],
  genres: ["Action", "Adventure", "Comedy", "Drama", "Family", "Horror", "Romantic", "Sci-Fi", "Sports", "Thriller"],
  formats: ["2D", "3D", "4DX", "IMAX", "Dolby Digital"],
};

export default filterData;
